<p-autoComplete [ngModel]="valeur"
                (ngModelChange)="onValeurChange($event)"
                [suggestions]="lieuxCherches()"
                [multiple]="true"
                [forceSelection]="true"
                [disabled]="desactive"
                (completeMethod)="completeMethodLieu($event)"
                appendTo="body">
</p-autoComplete>
